import * as fromDatatype from "../datatype-library/index";

export interface bl_del_slot_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	delivery_region_guid: fromDatatype.GuidDataFieldInterface;
	delivery_slot_running_no: fromDatatype.BigIntegerDatatypeInterface;
	start_date_time: fromDatatype.TimestampTzDatatypeInterface;
	end_date_time: fromDatatype.TimestampTzDatatypeInterface;
	session_duration: fromDatatype.NumericDatatypeInterface;
	session_count: fromDatatype.IntegerDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
    sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
    position_id: fromDatatype.IntegerDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    timezone: fromDatatype.VarcharDatatypeInterface;
    is_full_day: boolean;
    visibility_setting: fromDatatype.VarcharDatatypeInterface;
    recurring_group_01_guid: fromDatatype.GuidDataFieldInterface;
    recurring_group_02_guid: fromDatatype.GuidDataFieldInterface;
    rrule: fromDatatype.VarcharDatatypeInterface;
    is_recurring: boolean;
    recurring_update_type: fromDatatype.VarcharDatatypeInterface;
}

export class bl_del_slot_hdr_RowClass implements bl_del_slot_hdr_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	delivery_region_guid: fromDatatype.GuidDataFieldInterface;
	delivery_slot_running_no: fromDatatype.BigIntegerDatatypeInterface;
	start_date_time: fromDatatype.TimestampTzDatatypeInterface;
	end_date_time: fromDatatype.TimestampTzDatatypeInterface;
	session_duration: fromDatatype.NumericDatatypeInterface;
	session_count: fromDatatype.IntegerDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
    sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
    position_id: fromDatatype.IntegerDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    timezone: fromDatatype.VarcharDatatypeInterface;
    is_full_day: boolean;
    visibility_setting: fromDatatype.VarcharDatatypeInterface;
    recurring_group_01_guid: fromDatatype.GuidDataFieldInterface;
    recurring_group_02_guid: fromDatatype.GuidDataFieldInterface;
    rrule: fromDatatype.VarcharDatatypeInterface;
    is_recurring: boolean;
    recurring_update_type: fromDatatype.VarcharDatatypeInterface;
}